import React from "react";
import { Form, Modal } from "react-bootstrap";
import "react-calendar/dist/Calendar.css";

const TimeOfDayModal = (props) => {
  return (
    <Modal show={props.show} onHide={props.onHide} size="sm" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton>
        <h5>What Time of Day?</h5>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="userDomainName">
            <Form.Control as="select" custom onChange={(value) => props.onTimeSelect(value.target.value)}>
              <option>Click Here For Options</option>
              <option>8:00 AM</option>
              <option>9:00 AM</option>
              <option>10:00 AM</option>
              <option>11:00 AM</option>
              <option>12:00 PM</option>
              <option>1:00 PM</option>
              <option>2:00 PM</option>
              <option>3:00 PM</option>
              <option>4:00 PM</option>
              <option>5:00 PM</option>
            </Form.Control>
            <p className="text-center mt-3 mb-0" style={{ color: "gray" }}>
              *All times are Central
            </p>
          </Form.Group>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default TimeOfDayModal;
